<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Text } from '@Shelly/shelly-design-system';
	import DayPicker from '../../../../../../../../TimePicker/DayPicker.svelte';
	import type { DailyWeeklyCondition } from '../../../../../../../../../types/TimeBasedConditionsUI';
	import TimePickerWrapper from '../../../../../../../../TimePicker/TimePickerWrapper.svelte';

	export let value: DailyWeeklyCondition;
</script>

<Text class="mb-s" styleType="h2">
	{$format('choose_weekday')}
</Text>
<!--Use on:change event handler to trigger value.isin change event and reflect to the parent component,
    otherwise whe array changes, but the parent does not know about changes, and isValid check to enable save button does not workk
-->
<DayPicker class="mb-m" days={value.isin} on:change={(e) => (value.isin = e.detail)} />

<Text class="mb-s text-center" styleType="h2">
	{$format('choose_time')}
</Text>
<div class="text-center">
	<TimePickerWrapper bind:time={value.time} />
</div>
